<template>
  <input type="text" :value="modelValue" :style="style" :disabled="disabled" :placeholder="placeholder" :maxlength="wordLimit" @input="handleChange" class="text-input" />
</template>

<script setup>
import { debounce } from 'lodash'
import Toast from '@/h5/components/toast'
import LGSdk from '@/packages/plugins/languageSDK/index'

const props = defineProps({
  modelValue: [String, Number],
  placeholder: String,
  wordLimit: Number,
  disabled: Boolean,
  style: {
    type: Object,
    default: () => {}
  }
})

const emits = defineEmits(['update:modelValue', 'change'])

const showToast = debounce(
  (customMessage) => {
    Toast && Toast({ message: customMessage, duration: 1500 })
  },
  500,
  { leading: true, trailing: false }
)

const handleChange = (e) => {
  emits('update:modelValue', e.target.value)
  emits('change', e.target.value)

  if (props.wordLimit <= e.target.value?.length) {
    showToast(LGSdk.t('survey.maxInput'))
  }
}
</script>

<style scoped>
.text-input {
  width: 40%;
}
</style>
